import { render, staticRenderFns } from "./InfrainsuranceEditCard.vue?vue&type=template&id=6c73ebe1&"
import script from "./InfrainsuranceEditCard.vue?vue&type=script&lang=js&"
export * from "./InfrainsuranceEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports